import bService from './base-api'
import { CONTRACT_MANAGER_URL } from '../configs/service-url'

const list = async () => {
  const url = CONTRACT_MANAGER_URL.USER
  const result = await bService.get(url)

  return result
}

const create = async (data) => {
  const url = CONTRACT_MANAGER_URL.USER
  const result = await bService.post(url, data)

  return result
}

const update = async (userId, data) => {
  const url = `${CONTRACT_MANAGER_URL.USER}/${userId}`
  const result = await bService.put(url, data)

  return result
}

const remove = async (userId) => {
  const userUrl = CONTRACT_MANAGER_URL.USER
  const url = `${userUrl}/${userId}`

  const result = await bService.remove(url)

  return result
}

const resetPassword = async (userId, isRandomPassword, newPassword) => {
  const userUrl = CONTRACT_MANAGER_URL.USER
  const url = `${userUrl}/reset-password/${userId}`
  const data = {
    isRandomPassword: isRandomPassword,
    newPassword: newPassword
  }

  const result = await bService.put(url, data)

  return result
}

export default {
  list,
  create,
  update,
  remove,
  resetPassword
}
